<template>
  <div class="nodes">
    <modal ref="editModal" :title="modalTitle">
      <template #content>
        <node-edit-form
          ref="editForm"
          @onClickSave="hideModal(true)"
          @onClickExit="hideModal(false)"
          @onClickReturnSelect="hideModal(false),showSelectionModal()"
        />
      </template>
    </modal>

    <!--Modal de seleccion de tipo de configuración-->
    <b-modal
      ref="selectionModal"
      hide-header
      hide-footer
      centered
      size="xl"
      scrollable
      style="box-sizing: border-box;"
    >
      <div id="seleccion">
        <b-card
          title="Tipo de configuración"
          class="mb-2"
          style="padding: 30px"
        >
          <b-card-text>
            ¿Qué tipo de configuración desea realizar?
          </b-card-text>
          <b-row style="margin-top: 50px;">
            <b-col>

              <b-card
                title="Configuración manual"
                id="manual"
                @click="showModal(), hideSelectionModal()"                              
              >
                <div>
                  <b-card-text style="color: black; font-size: 0.95rem">
                    Configuración clásica. Formulario de creación manual de
                    nuevo nodo en el que se introducen los campos a mano.
                  </b-card-text>
                </div>
              </b-card>

            </b-col>
            <b-col>

              <b-card
                title="Configuración asistida"
                id="wizard"
                @click="showWizardModal(), hideSelectionModal()"
              >
                <div>
                  <b-card-text style="color: black; font-size: 0.95rem" >
                    Configuración guiada paso por paso para la creación de un
                    nuevo nodo. Permite asociar una plantilla de sensores
                    predeterminada.
                  </b-card-text>
                </div>
              </b-card>

            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-modal>

    <b-modal
      ref="wizardModal"
      hide-header
      centered
      size="xl"
    >
      <form-wizard></form-wizard>
      <template #modal-footer>
        <div class="w-100">
          
          <b-button
            variant="info"
            size="sm"
            class="float-left"
            @click="hideWizardModal(),showSelectionModal()"
          >
            Volver a tipo de configuración
          </b-button>
        </div>
      </template>
    </b-modal>

    <modal ref="helpModal" :title="modalTitle">
      <template #content>
        <help-nodes></help-nodes>
      </template>
    </modal>

    <div>
      <b-card class="md-3">
        <b-row>
          <b-col cols="10">
            <!-- Boton registrar nodo (WIZARD) INICIO -->
            <b-button
              class="buttonClass"
              variant="success"
              size="sm"
              style="!important"
              @click="showSelectionModal()"
              v-if="isUserAdmin()"
            >
              <i class="fas fa-plus" style="margin-right: 5px"></i>
              <span
                class="text-uppercase"
                style="font-weight: 600; font-size: 13px"
                >Registrar nuevo nodo</span
              >
            </b-button>
            <!-- Boton registrar nodo (WIZARD) FIN-->
          </b-col>
          <b-col>
            <div>
              <img
                title="Ayuda"
                class="botonAyuda"
                :src="getImgUrl('help.svg')"
                @click="showModalHelp()"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <spacer-card></spacer-card>

    <b-row>
      <b-col>
        <nodes-table ref="nodeTable" @rowedit="showModal" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Modal from "@/components/common/Modal";
import Button from "@/components/common/form/Button";
import NodesTable from "@/components/nodes/NodesTable";
import NodeEditForm from "@/components/nodes/NodesEditForm";
import Wizard from "@/components/wizard/Wizard";
import Spacer from "@/components/card/Spacer";
import UserService from "@/services/UserService";
import HelpNodes from "@/components/help/HelpNodes";

export default {
  data() {
    return {
      modalTitle: "",
    };
  },
  components: {
    "nodes-table": NodesTable,
    "node-edit-form": NodeEditForm,
    "form-wizard": Wizard,
    modal: Modal,
    "spacer-card": Spacer,
    "form-button": Button,
    "help-nodes": HelpNodes,
  },
  methods: {
    showModal(idnodo) {
      //Ver si hay que poner el modal en modo edición o como nuevo psando el ID
      this.modalTitle = idnodo ? "Nodo - Modificar" : "Nodo - Agregar nuevo";
      this.$refs.editModal.show();

      if (idnodo) {
        this.$nextTick(() => {
          // DOM updated
          this.$refs.editForm.getDevice(idnodo);
        });
      }
    },

    showSelectionModal() {
      this.$refs.selectionModal.show();
    },
    hideSelectionModal(){
      this.$refs.selectionModal.hide();
    },

    showWizardModal() {
      this.$refs.wizardModal.show();
    },
    hideWizardModal(){
      this.$refs.wizardModal.hide();
    },

    showModalHelp() {
      this.modalTitle = "Ayuda - Nuevo nodo";
      this.$refs.helpModal.show();
    },

    /**
     * @description Método que oculta la ventana modal y puede realizar otras acciones
     * @param {boolean} refreshList Indica si hay que refrescar la lista
     */
    hideModal(refreshList) {
      this.$refs.editModal.hide();

      if (refreshList) {
        this.$refs.nodeTable.refreshList();
      }
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    getImgUrl(image) {
      return require("@/assets/images/" + image);
    },
  },
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style scoped>
.botonAyuda {
  width: 30px;
  margin-right: 10px;
  padding: 2px;
  float: right;
  cursor: pointer;
}

.botonAyuda:hover {
  padding: 0px;
}

#manual {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/manual.png");
  background-repeat: no-repeat;
  background-size: 300px 250px;
  background-position: center;   
}
#manual:hover{
  background-color: skyblue;
  cursor: pointer;
  border: solid;
  border-color: skyblue;
}
#manual:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.80;
  position: absolute;
}
#manual div {
  position: relative;
  padding: 50px;
}

#wizard {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/wizard_hat.png");
  background-repeat: no-repeat;
  background-size: 300px 250px;
  background-position: center;
}
#wizard:hover{
  background-color:skyblue;
  cursor: pointer;
  border: solid;
  border-color: skyblue;
}
#wizard:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.80;
  position: absolute;
}
#wizard div {
  position: relative;
  padding: 50px;
}
#seleccion {
  text-align: center;
}
</style>